import config from 'config/config';
import React, { createContext, Dispatch, FC, SetStateAction, useMemo, useState } from 'react';

interface AppGlobalAlertProviderProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export const AppGlobalAlertContext = createContext<AppGlobalAlertProviderProps>({
  open: false,
  setOpen: () => {},
});
export const AppGlobalAlertProvider: FC = ({ children }) => {
  const isOpen = useMemo(() => {
    if (config.globalAlertMessage === 'Off') {
      return false;
    }

    return Boolean(config.globalAlertMessage);
  }, []);

  const [open, setOpen] = useState(isOpen);

  return (
    <AppGlobalAlertContext.Provider value={{ open, setOpen }}>
      {children}
    </AppGlobalAlertContext.Provider>
  );
};
